import { render, staticRenderFns } from "./ContentPanel.vue?vue&type=template&id=43beecf8"
import script from "./ContentPanel.vue?vue&type=script&lang=ts"
export * from "./ContentPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports